import React, { useEffect } from "react";
import { Box } from "@mui/material";
import HeroSection from "../../components/heroSection/hero";
import Contact from "../../components/contactSection/contact";
import BgImage from "../../images/about/background.png";
import AboutUs from "../../components/aboutus/about";
import { internshipLink } from "../../common/routes";

function AboutPage() {
  const ContactText = "Interseted in joining our team";
  const ContactButtonText = "Explore job opportunities";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box>
      <HeroSection heroBgImage={BgImage} text={"About us"} />
      <AboutUs />
      <Contact text={ContactText} buttonText={ContactButtonText} url={internshipLink} />
    </Box>
  );
}

export default AboutPage;
